export default function loadGame() {
	(
		function () {
			'use strict';

			function loadGame() {
				let wrap = document.getElementById( 'js_game' );
				if ( wrap ) {
					let btn = wrap.getElementsByTagName( 'button' )[0];

					function onClick() {
						let frame = document.createElement( 'iframe' );
						let src = wrap.getAttribute( 'data-game' );

						frame.setAttribute( 'src', src );
						btn.removeEventListener( 'click', onClick );
						wrap.innerHTML = '';
						wrap.appendChild( frame );
					}

					if ( btn ) {
						btn.addEventListener( 'click', onClick );
					}
				}
			}

			loadGame();
		}
	)();
}